import { reactive } from "vue"

const state = reactive({
    selected: 'profile',
    isOpened: false,
})

export const useSidebar = () => {

    const setSelected = (value: string) => {
        state.selected = value
    }

    const setIsOpened = (value: boolean) => {
        state.isOpened = value
    }

    return {
        state,
        setSelected,
        setIsOpened,
    }
}